import React from 'react';
import {useTranslation} from 'react-i18next';
import Select from "./Select";

const ReserveUsedSelector = ({value, setValue, disabled, required}) => {
    const {t} = useTranslation();

    return <Select
        label={t('reserve_used_selector')}
        value={value}
        onChange={e => setValue(e.target.value)}
        optionKey='Key'
        optionValue='Value'
        allowEmpty={false}
        options={[
            {Key: 'all', Value: t('reserve_used_selector_all')},
            {Key: 'Y', Value: t('reserve_used_selector_Y')},
            {Key: 'N', Value: t('reserve_used_selector_N')},
        ]}
        inputProps={{
            disabled: disabled,
            variant: 'outlined',
            fullWidth: true,
            required: required
        }}
    />;
};

export default ReserveUsedSelector;